import { render, staticRenderFns } from "./gallery_modal.vue?vue&type=template&id=2d27b4c8&"
import script from "./gallery_modal.vue?vue&type=script&lang=js&"
export * from "./gallery_modal.vue?vue&type=script&lang=js&"
import style0 from "./gallery_modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports